import BadgesPage from "../../views/BadgesPage";
import CreatePassword from "../../views/CreatePassword";
import EmailForHelp from "../../views/EmailForHelp";
import ErrorInfo from "../../views/ErrorInfo";
import OneTimeLogin from "../../views/OneTimeLogin";
import SignIn from "../../views/SignIn";
import Submitting from "../../views/Submitting";
import SurveyQuestionPage from "../../views/SurveyQuestionPage";
import WelcomePage from "../../views/WelcomePage";
import { useFormFlowContext } from "./FormFlowContext";

/**
 * FormContent component handles the rendering of different form views based on the current view state.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.formMethods - Methods for handling form state and validation.
 * @param {Function} props.handleSubmit - Function to handle form submission.
 *
 * @returns {JSX.Element} The rendered component.
 */
export default function FormContent({ formMethods, handleSubmit }) {
  const {
    currentView,
    noAccountsExperience,
    auth0OnlyExperience,
    pageForward,
    formError,
    setCurrentPage,
    setFormError,
    setSubmittingMessage,
    setFormSuccess,
    setView
  } = useFormFlowContext();

  const handleClickPersonalizeLater = () => {
    pageForward();
    if (noAccountsExperience) {
      setView("password");
    }
  };

  const handleErrorBack = (errorBackData) => {
    setFormSuccess(false);

    if (auth0OnlyExperience && formMethods?.setValueChange) {
      formMethods.setValueChange("password", "");
    }

    setFormError();

    if (errorBackData?.currentPage !== null && errorBackData?.currentPage !== undefined) {
      setCurrentPage(errorBackData.currentPage);
    }

    setView(errorBackData?.view || "welcome");
  };

  if (formError) {
    return <ErrorInfo errorBack={handleErrorBack} {...formError} />;
  }

  switch (currentView) {
    case "signin":
      return <SignIn />;
    case "welcome":
      return <WelcomePage formMethods={formMethods} />;
    case "badges":
      return (
        <BadgesPage
          handleClickPersonalizeLater={handleClickPersonalizeLater}
          formMethods={formMethods}
        />
      );

    case "survey":
      return (
        <SurveyQuestionPage
          formMethods={formMethods}
          handleClickPersonalizeLater={handleClickPersonalizeLater}
        />
      );

    case "password":
      return (
        <CreatePassword
          formMethods={formMethods}
          onClickCreateAccount={() => {
            setSubmittingMessage("Creating your account...");
            handleSubmit();
          }}
        />
      );

    case "submitting":
      return <Submitting />;

    case "wrong_info":
      return <EmailForHelp />;

    case "login_issues__signin":
    case "login_issues__one_time_login":
      return <EmailForHelp reason="login-issues" />;

    case "one_time_login":
      return <OneTimeLogin />;

    default:
      return <ErrorInfo errorBack={handleErrorBack} />;
  }
}
